import { PlaceTab, PlaceTabSchema } from './place-details.types'

// Note: the perks tab is locked while the building's perks feature is off
export const isPlaceTabDisabled = (tab: PlaceTab, perksAvailable: boolean) =>
  tab === PlaceTab.perks && !perksAvailable

// Note: tabs only an Administrator sees - Languages is an Administrator-only setting (EL-13870)
export const isPlaceTabHidden = (tab: PlaceTab, isAdmin: boolean) =>
  tab === PlaceTab.languages && !isAdmin

export const resolveActiveTab = (
  rawTab: string | null,
  perksAvailable = true,
  isAdmin = false,
): PlaceTab => {
  const parsed = PlaceTabSchema.safeParse(rawTab)
  if (
    !parsed.success ||
    isPlaceTabDisabled(parsed.data, perksAvailable) ||
    isPlaceTabHidden(parsed.data, isAdmin)
  )
    return PlaceTab.general
  return parsed.data
}
